/*****************************************************************************************
 * 설명 : 어플리케이션 설정
 *****************************************************************************************/
export const version = '1.0.15'

// 기본 접속 주소
export const baseHost = window.location.hostname === 'localhost'
  ? 'http://localhost:8089'
  : window.location.hostname.indexOf('o2oz') > -1
  ? 'http://cert.o2oz.net'
  : 'https://cert.ref.or.kr';

export const baseImgUrl = baseHost;

export const baseURL = baseHost;

// 행정정보 공동이용 서비스 주소
export const discountURL = baseURL;

export const PAGEROW = 20

export const MESSAGE_DELAY = 3000;
